import { IncomeLimitData, IncomeLimits } from '../../configs/types';

export const njCountyIncomeLimitsData = Object.freeze({
  atlantic: [
    '$56,150',
    '$64,150',
    '$72,150',
    '$80,150',
    '$86,600',
    '$93,000',
    '$99,400',
    '$105,800',
  ],
  bergen: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  burlington: [
    '$66,850',
    '$76,400',
    '$85,950',
    '$95,500',
    '$103,150',
    '$110,800',
    '$118,450',
    '$126,100',
  ],
  camden: [
    '$66,850',
    '$76,400',
    '$85,950',
    '$95,500',
    '$103,150',
    '$110,800',
    '$118,450',
    '$126,100',
  ],
  'cape may': [
    '$67,550',
    '$77,200',
    '$86,850',
    '$96,500',
    '$104,250',
    '$111,950',
    '$119,700',
    '$127,400',
  ],
  cumberland: [
    '$51,950',
    '$59,350',
    '$66,750',
    '$74,150',
    '$80,100',
    '$86,050',
    '$91,950',
    '$97,900',
  ],
  essex: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  gloucester: [
    '$66,850',
    '$76,400',
    '$85,950',
    '$95,500',
    '$103,150',
    '$110,800',
    '$118,450',
    '$126,100',
  ],
  hudson: [
    '$75,050',
    '$85,800',
    '$96,500',
    '$107,200',
    '$115,800',
    '$124,400',
    '$132,950',
    '$141,550',
  ],
  hunterdon: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  mercer: [
    '$71,050',
    '$81,200',
    '$91,350',
    '$101,500',
    '$109,650',
    '$117,750',
    '$125,900',
    '$134,000',
  ],
  middlesex: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  monmouth: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  morris: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  ocean: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  passaic: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  salem: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  somerset: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  sussex: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  union: [
    '$72,950',
    '$83,400',
    '$93,800',
    '$104,200',
    '$112,550',
    '$120,900',
    '$129,250',
    '$137,550',
  ],
  warren: [
    '$70,400',
    '$80,450',
    '$90,500',
    '$100,550',
    '$108,600',
    '$116,650',
    '$124,700',
    '$132,750',
  ],
});

export const MAX_HOUSEHOLD_OCCUPANCY_LIMIT = 8;
export const njDefaultCounties = Object.freeze([
  'Atlantic County',
  'Bergen County',
  'Burlington County',
  'Camden County',
  'Cape may County',
  'Cumberland County',
  'Essex County',
  'Gloucester County',
  'Hudson County',
  'Hunterdon County',
  'Mercer County',
  'Middlesex County',
  'Monmouth County',
  'Morris County',
  'Ocean County',
  'Passaic County',
  'Salem County',
  'Somerset County',
  'Sussex County',
  'Union County',
  'Warren County',
]);

const countyIncomeLimitsData = Object.freeze({
  aitkin: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  anoka: [
    '$130,450',
    '$149,050',
    '$167,700',
    '$186,300',
    '$201,250',
    '$216,150',
    '$231,050',
    '$245,950',
  ],
  becker: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  beltrami: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  benton: [
    '$98,200',
    '$112,200',
    '$126,250',
    '$140,250',
    '$151,500',
    '$162,700',
    '$173,950',
    '$185,150',
  ],
  'big stone': [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  'blue earth': [
    '$100,100',
    '$114,400',
    '$128,700',
    '$142,950',
    '$154,400',
    '$165,850',
    '$177,300',
    '$188,700',
  ],
  brown: [
    '$96,200',
    '$109,200',
    '$122,850',
    '$136,500',
    '$147,450',
    '$158,350',
    '$169,300',
    '$180,200',
  ],
  carlton: [
    '$96,200',
    '$108,400',
    '$121,950',
    '$135,450',
    '$146,300',
    '$157,150',
    '$168,000',
    '$178,800',
  ],
  carver: [
    '$130,450',
    '$149,050',
    '$167,700',
    '$186,300',
    '$201,250',
    '$216,150',
    '$231,050',
    '$245,950',
  ],
  cass: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  chippewa: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  chisago: [
    '$130,450',
    '$149,050',
    '$167,700',
    '$186,300',
    '$201,250',
    '$216,150',
    '$231,050',
    '$245,950',
  ],
  clay: [
    '$109,350',
    '$124,950',
    '$140,550',
    '$156,150',
    '$168,650',
    '$181,150',
    '$193,650',
    '$206,150',
  ],
  clearwater: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  cook: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  cottonwood: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  'crow wing': [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  dakota: [
    '$130,450',
    '$149,050',
    '$167,700',
    '$186,300',
    '$201,250',
    '$216,150',
    '$231,050',
    '$245,950',
  ],
  dodge: [
    '$123,900',
    '$141,600',
    '$159,300',
    '$177,000',
    '$191,200',
    '$205,350',
    '$219,500',
    '$233,650',
  ],
  douglas: [
    '$98,600',
    '$112,700',
    '$126,800',
    '$140,850',
    '$152,150',
    '$163,400',
    '$174,700',
    '$185,950',
  ],
  faribault: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  fillmore: [
    '$96,400',
    '$110,200',
    '$123,950',
    '$137,700',
    '$148,750',
    '$159,750',
    '$170,750',
    '$181,800',
  ],
  freeborn: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  goodhue: [
    '$107,650',
    '$123,000',
    '$138,400',
    '$153,750',
    '$166,050',
    '$178,350',
    '$190,650',
    '$202,950',
  ],
  grant: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  hennepin: [
    '$130,450',
    '$149,050',
    '$167,700',
    '$186,300',
    '$201,250',
    '$216,150',
    '$231,050',
    '$245,950',
  ],
  houston: [
    '$98,100',
    '$112,100',
    '$126,100',
    '$140,100',
    '$151,350',
    '$162,550',
    '$173,750',
    '$184,950',
  ],
  hubbard: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  isanti: [
    '$130,450',
    '$149,050',
    '$167,700',
    '$186,300',
    '$201,250',
    '$216,150',
    '$231,050',
    '$245,950',
  ],
  itasca: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  jackson: [
    '$96,200',
    '$106,200',
    '$119,500',
    '$132,750',
    '$143,400',
    '$154,000',
    '$164,650',
    '$175,250',
  ],
  kanabec: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  kandiyohi: [
    '$96,200',
    '$106,200',
    '$119,500',
    '$132,750',
    '$143,400',
    '$154,000',
    '$164,650',
    '$175,250',
  ],
  kittson: [
    '$96,200',
    '$106,100',
    '$119,350',
    '$132,600',
    '$143,250',
    '$153,850',
    '$164,450',
    '$175,050',
  ],
  koochiching: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  'lac qui parle': [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  lake: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  'lake of the woods': [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  'le sueur': [
    '$107,850',
    '$123,250',
    '$138,650',
    '$154,050',
    '$166,400',
    '$178,700',
    '$191,050',
    '$203,350',
  ],
  lincoln: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  lyon: [
    '$96,200',
    '$106,200',
    '$119,500',
    '$132,750',
    '$143,400',
    '$154,000',
    '$164,650',
    '$175,250',
  ],
  mahnomen: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  marshall: [
    '$96,200',
    '$107,650',
    '$121,100',
    '$134,550',
    '$145,350',
    '$156,100',
    '$166,850',
    '$177,650',
  ],
  martin: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  mcleod: [
    '$98,700',
    '$112,800',
    '$126,900',
    '$141,000',
    '$152,300',
    '$163,600',
    '$174,850',
    '$186,150',
  ],
  meeker: [
    '$96,850',
    '$110,650',
    '$124,500',
    '$138,300',
    '$149,400',
    '$160,450',
    '$171,500',
    '$182,600',
  ],
  'mille lacs': [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  morrison: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  mower: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  murray: [
    '$96,200',
    '$108,600',
    '$122,200',
    '$135,750',
    '$146,650',
    '$157,500',
    '$168,350',
    '$179,200',
  ],
  nicollet: [
    '$100,100',
    '$114,400',
    '$128,700',
    '$142,950',
    '$154,400',
    '$165,850',
    '$177,300',
    '$188,700',
  ],
  nobles: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  norman: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  olmsted: [
    '$123,900',
    '$141,600',
    '$159,300',
    '$177,000',
    '$191,200',
    '$205,350',
    '$219,500',
    '$233,650',
  ],
  'otter tail': [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  pennington: [
    '$96,200',
    '$106,200',
    '$119,500',
    '$132,750',
    '$143,400',
    '$154,000',
    '$164,650',
    '$175,250',
  ],
  pine: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  pipestone: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  polk: [
    '$100,500',
    '$114,850',
    '$129,200',
    '$143,550',
    '$155,050',
    '$166,550',
    '$178,050',
    '$189,500',
  ],
  pope: [
    '$96,400',
    '$110,200',
    '$123,950',
    '$137,700',
    '$148,750',
    '$159,750',
    '$170,750',
    '$181,800',
  ],
  ramsey: [
    '$130,450',
    '$149,050',
    '$167,700',
    '$186,300',
    '$201,250',
    '$216,150',
    '$231,050',
    '$245,950',
  ],
  'red lake': [
    '$96,200',
    '$108,500',
    '$122,050',
    '$135,600',
    '$146,450',
    '$157,300',
    '$168,150',
    '$179,000',
  ],
  redwood: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  renville: [
    '$96,200',
    '$106,200',
    '$119,500',
    '$132,750',
    '$143,400',
    '$154,000',
    '$164,650',
    '$175,250',
  ],
  rice: [
    '$97,650',
    '$111,600',
    '$125,550',
    '$139,500',
    '$150,700',
    '$161,850',
    '$173,000',
    '$184,150',
  ],
  rock: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  roseau: [
    '$96,200',
    '$106,700',
    '$120,050',
    '$133,350',
    '$144,050',
    '$154,700',
    '$165,400',
    '$176,050',
  ],
  scott: [
    '$130,450',
    '$149,050',
    '$167,700',
    '$186,300',
    '$201,250',
    '$216,150',
    '$231,050',
    '$245,950',
  ],
  sherburne: [
    '$130,450',
    '$149,050',
    '$167,700',
    '$186,300',
    '$201,250',
    '$216,150',
    '$231,050',
    '$245,950',
  ],
  sibley: [
    '$96,200',
    '$108,000',
    '$121,500',
    '$135,000',
    '$145,800',
    '$156,600',
    '$167,400',
    '$178,200',
  ],
  'st. louis': [
    '$96,200',
    '$108,400',
    '$121,950',
    '$135,450',
    '$146,300',
    '$157,150',
    '$168,000',
    '$178,800',
  ],
  stearns: [
    '$98,200',
    '$112,200',
    '$126,250',
    '$140,250',
    '$151,500',
    '$162,700',
    '$173,950',
    '$185,150',
  ],
  steele: [
    '$100,800',
    '$115,200',
    '$129,600',
    '$144,000',
    '$155,550',
    '$167,050',
    '$178,600',
    '$190,100',
  ],
  stevens: [
    '$103,750',
    '$118,600',
    '$133,400',
    '$148,200',
    '$160,100',
    '$171,950',
    '$183,800',
    '$195,650',
  ],
  swift: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  todd: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  traverse: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  wabasha: [
    '$99,350',
    '$113,550',
    '$127,750',
    '$141,900',
    '$153,300',
    '$164,650',
    '$176,000',
    '$187,350',
  ],
  wadena: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  waseca: [
    '$96,200',
    '$106,200',
    '$119,500',
    '$132,750',
    '$143,400',
    '$154,000',
    '$164,650',
    '$175,250',
  ],
  washington: [
    '$130,450',
    '$149,050',
    '$167,700',
    '$186,300',
    '$201,250',
    '$216,150',
    '$231,050',
    '$245,950',
  ],
  watonwan: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  wilkin: [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
  winona: [
    '$97,150',
    '$111,000',
    '$124,900',
    '$138,750',
    '$149,850',
    '$160,950',
    '$172,050',
    '$183,150',
  ],
  wright: [
    '$130,450',
    '$149,050',
    '$167,700',
    '$186,300',
    '$201,250',
    '$216,150',
    '$231,050',
    '$245,950',
  ],
  'yellow medicine': [
    '$96,200',
    '$105,850',
    '$119,100',
    '$132,300',
    '$142,900',
    '$153,500',
    '$164,100',
    '$174,650',
  ],
});

export const mnDefaultCounties = Object.freeze([
  'Aitkin County',
  'Anoka County',
  'Becker County',
  'Beltrami County',
  'Benton County',
  'Big Stone County',
  'Blue Earth County',
  'Brown County',
  'Carlton County',
  'Carver County',
  'Cass County',
  'Chippewa County',
  'Chisago County',
  'Clay County',
  'Clearwater County',
  'Cook County',
  'Cottonwood County',
  'Crow Wing County',
  'Dakota County',
  'Dodge County',
  'Douglas County',
  'Faribault County',
  'Fillmore County',
  'Freeborn County',
  'Goodhue County',
  'Grant County',
  'Hennepin County',
  'Houston County',
  'Hubbard County',
  'Isanti County',
  'Itasca County',
  'Jackson County',
  'Kanabec County',
  'Kandiyohi County',
  'Kittson County',
  'Koochiching County',
  'Lac Qui Parle County',
  'Lake County',
  'Lake Of The Woods County',
  'Le Sueur County',
  'Lincoln County',
  'Lyon County',
  'Mahnomen County',
  'Marshall County',
  'Martin County',
  'Mc Leod County',
  'Meeker County',
  'Mille Lacs County',
  'Morrison County',
  'Mower County',
  'Murray County',
  'Nicollet County',
  'Nobles County',
  'Norman County',
  'Olmsted County',
  'Otter Tail County',
  'Pennington County',
  'Pine County',
  'Pipestone County',
  'Polk County',
  'Pope County',
  'Ramsey County',
  'Red Lake County',
  'Redwood County',
  'Renville County',
  'Rice County',
  'Rock County',
  'Roseau County',
  'Saint Louis County',
  'Scott County',
  'Sherburne County',
  'Sibley County',
  'Stearns County',
  'Steele County',
  'Stevens County',
  'Swift County',
  'Todd County',
  'Traverse County',
  'Wabasha County',
  'Wadena County',
  'Waseca County',
  'Washington County',
  'Watonwan County',
  'Wilkin County',
  'Winona County',
  'Wright County',
  'Yellow Medicine',
]);

export const assistancePrograms = {
  liheap: 'Low Income Home Energy Assistance Program (LIHEAP)',
  usf: 'Universal Service Fund (USF)',
  comfortPartners: 'Comfort Partners',
  lifelineUtilityAssistanceProgram: 'Lifeline utility assistance program',
  page: 'Payment Assistance for Gas and Electric (PAGE)',
  section8HousingChoiceVoucherProgram:
    'Section 8 Housing Choice Voucher Program',
  snap: 'Supplemental Nutrition Assistance Program (SNAP)',
  lifelineProgram:
    'Lifeline program (Universal Service Administrative Company)',
  medicaid: 'Medicaid',
  ssiOrSsdi:
    'Supplemental Security Income (SSI) or Social Security Disability Insurance (SSDI)',
  wic: 'Special Supplemental Nutrition Program for Women, Infants, and Children (WIC)',
  tanf: 'Temporary Assistance for Needy Families (TANF)',
  lihwap: 'Low-Income Household Water Assistance Program (LIHWAP)',
};

export const MnLmiCountyIncomeLimits = (() => {
  return {
    getIncomeLimits: (countyName: string, occupancy: number) => {
      if (countyIncomeLimitsData[countyName]) {
        return countyIncomeLimitsData[countyName][occupancy];
      }
    },
  };
})();

export const NjLmiCountyIncomeLimits = (() => {
  return {
    getIncomeLimits: (countyName: string, occupancy: number) => {
      if (njCountyIncomeLimitsData[countyName]) {
        return njCountyIncomeLimitsData[countyName][occupancy];
      }
    },
  };
})();

/**
 * Normalizes a county name for use as a lookup key.
 * Removes a trailing "County" suffix (case-insensitive), trims surrounding
 * whitespace, and converts to uppercase. Special characters such as hyphens,
 * apostrophes, periods, and internal spaces are preserved.
 *
 * Examples:
 *   'Essex County'      → 'ESSEX'
 *   'New York County'   → 'NEW YORK'
 *   "Prince George's County" → "PRINCE GEORGE'S"
 *   'County'            → ''
 */
export function formatCountyNameForLookup(countyName: string): string {
  const trimmed = String(countyName).trim();
  if (!trimmed) return '';
  // Remove trailing "County" suffix with optional surrounding whitespace
  const stripped = trimmed.replace(/\s*county\s*$/i, '').trim();
  return stripped.toUpperCase();
}

/**
 * Returns the income limit as a number for a given county name and household
 * occupancy. Returns null when no matching entry is found or the stored value
 * is non-numeric.
 *
 * Supported value shapes (matching the IncomeLimits type):
 *   1. string[] ordered by household size (1-indexed); values may be
 *      dollar-formatted, e.g. '$56,150':
 *        { 'essex': ['$56,150', '$64,150', ...] }
 *   2. IncomeLimitData[] keyed by houseOccupancy; the format returned by the
 *      API for MA and MN (key may be camelCase with or without "County"):
 *        { 'suffolkCounty': [{ houseOccupancy: 1, householdIncome: 50000 }, ...] }
 *
 * County keys are matched case-insensitively after stripping any trailing
 * "County" suffix (e.g. 'essex', 'Essex County', and 'ESSEX' all resolve to
 * the same entry).
 */
export function calculateIncomeLimit(
  countyName: string,
  houseOccupancy: string,
  incomeLimitsData: IncomeLimits | null | undefined
): number | null {
  if (!incomeLimitsData) return null;

  const countyKey = formatCountyNameForLookup(countyName);
  if (!countyKey) return null;

  const occupancyNum = parseInt(String(houseOccupancy).trim(), 10);
  if (isNaN(occupancyNum)) return null;

  // Try exact (uppercase) key first; fall back to a normalised match so that
  // API responses using lowercase, mixed-case, or "County"-suffixed keys
  // (e.g. 'essex', 'suffolkCounty') are resolved correctly.
  let countyData = incomeLimitsData[countyKey];
  if (countyData === undefined) {
    const matchKey = Object.keys(incomeLimitsData).find(
      k => formatCountyNameForLookup(k) === countyKey
    );
    if (matchKey !== undefined) countyData = incomeLimitsData[matchKey];
  }

  if (!countyData || countyData.length === 0) return null;

  // IncomeLimitData[] format: [{ houseOccupancy: number, householdIncome: number }, ...]
  if (typeof countyData[0] === 'object' && 'houseOccupancy' in countyData[0]) {
    const match = (countyData as IncomeLimitData[]).find(
      item => item.houseOccupancy === occupancyNum
    );
    return match != null ? match.householdIncome : null;
  }

  // string[] format: dollar-formatted strings ordered by household size (1-indexed)
  const index = occupancyNum - 1;
  const rawValue = (countyData as string[])[index];
  if (rawValue == null) return null;
  const n = Number(rawValue.replace(/[$,]/g, ''));
  return isNaN(n) ? null : n;
}
